import React from "react";
import { useAllTimeScanHistorySummary } from "./useScanHistorySummary";

interface HistoricalComparisonProps {
  currentScore: number;
  venueId: string;
}

export const HistoricalComparison = ({
  currentScore,
  venueId
}: HistoricalComparisonProps): React.ReactElement | null => {
  const { summary } = useAllTimeScanHistorySummary(venueId);
  const historicalAverage = summary?.historicalAverageScore ?? null;

  if (historicalAverage === null || historicalAverage <= 0) {
    return null;
  }

  const pointDiff = Math.abs(currentScore - historicalAverage);
  const direction = currentScore >= historicalAverage ? "above" : "below";

  return (
    <div role="note" aria-label="Historical score comparison">
      <p className="mt-1 text-xs text-[var(--secondaryColor)]">
        <span className="sr-only">Historical score comparison: </span>
        This is {pointDiff.toFixed(0)} points {direction} your venue&apos;s
        average score of {historicalAverage.toFixed(0)}%
      </p>
    </div>
  );
};
